export function roundTo4(n: number) {
  return 4 * Math.round(n / 4);
}
